import React, { FC, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { ProjectDto } from '@portal/client-portal-api-model';
import { ActionSpinner } from '@portal/frontend/react';

interface RemoveProjectModalProps {
  onHide: () => void;
  onConfirm: () => Promise<void>;
  show: boolean;
  project: ProjectDto | undefined;
}

export const RemoveProjectModal: FC<RemoveProjectModalProps> = ({
  onHide,
  show,
  onConfirm,
  project,
}) => {
  const [removingProject, setRemovingProject] = useState(false);

  const handleOnHide = () => {
    onHide();
    setRemovingProject(false);
  };

  if (!project) {
    return null;
  }

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
      onHide={handleOnHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          You are going to remove "{project.name}" project
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        All workitems created for this project will be deleted. Are you sure to
        proceed?
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleOnHide} variant="outline-primary">
          No
        </Button>
        <Button
          variant="danger"
          disabled={removingProject}
          onClick={async () => {
            setRemovingProject(true);
            try {
              await onConfirm();
            } catch (error) {
              console.error(error);
            } finally {
              handleOnHide();
            }
          }}
        >
          <ActionSpinner
            showSpinner={removingProject}
            defaultText={'Yes'}
            spinnerContent={'Removing...'}
          />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveProjectModal;
